'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fusionQBUrl = fusionQBUrl;

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CIRCLE_ID = 1015;

/* eslint-disable import/prefer-default-export */
/**
 * 融合帐号QB地址
 * @param  {String} options.id
 * @param  {String} options.ch
 * @param  {String} options.shareUrl 环境
 * @return {String}
 */
/*
 * @Author: edvardchen
 * @Date:   2017-03-24 16:34:19
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2017-03-24 17:08:54
 */

function fusionQBUrl(_ref) {
  var id = _ref.id,
      ch = _ref.ch,
      shareUrl = _ref.shareUrl;

  var params = {
    url: shareUrl,
    sh_na_id: CIRCLE_ID,
    circleid: id,
    channel: ch
  };

  return 'qb://ext/circle?' + _queryString2.default.stringify(params);
}